import moment from "moment";
import createReactClass from "create-react-class";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import _ from "underscore";
import Constants from "../constants/constants";
import { FormControl } from "react-bootstrap";
import { userStore } from "../stores/user";
import { formValidation } from "../util/formValidation";
//var sanitize = require('../util/formValidation').sanitizeInput;
var AllowedCommentCharacters = "A-Za-z0-9,. \n()'";

export const CommentModalView = createReactClass({

  getInitialState() {
    let comm = "";

    const { restriction } = this.props;

    if (restriction.comments) {
      comm = restriction.comments
        .sort(sortFunction).map(c => c.comment);
    }

    return {
      showModal: false,
      comments: comm.join("\n"),
      lineCount: comm.length,
      status: restriction.status
    };
  },
  componentDidUpdate() {
    setTimeout(
      function () {
        this.refs.commentRef && this.refs.commentRef.focus();
      }.bind(this),
      500
    );
  },
  close() {
    //call action creator to store the comment here...
    this.props.actionCreator.commentModalClosed(this.state.comments);
    this.setState({ showModal: false });
  },
  cancel() {
    this.setState({ showModal: false });
  },
  open() {
    var st = this.getInitialState();
    this.props.actionCreator.commentModalOpened(true);
    st.showModal = true;
    this.setState(st);
  },

  chunkText(str, length) {
    return str.replace(
      new RegExp(`(?![^\\n]{1,${length}}$)([^\\n]{1,${length}})\\s`, "g"),
      "$1\n"
    );
  },

  onChange(e) {
    var coms = [];

    //	/*there are two kinds of lines, those from a user pressing enter, and those that are wrapped because they
    //	* are longer than 80 chars in the textarea. This methods converts wrapped lines to user entered
    //	* lines so that when we store to the DB the line breaks are persisted correctly, since wrapped line
    //	* linebreaks can't be easily detected*/

    var input = formValidation.sanitizeInput(
      AllowedCommentCharacters,
      e.target.value
    );
    var userEnteredLines = input.split("\n");

    var l = userEnteredLines.length;

    for (var i = l - 1; i >= 0; i--) {
      //go through each line of user entered text

      //console.log(i,l, userEnteredLines[i]);
      if (
        userEnteredLines[i].length > Constants.MaxValues.MAX_COMMENT_LINE_LENGTH
      ) {
        //break this line into multiple lines at 80 char chunks
        var chunkedLines = this.chunkText(
          userEnteredLines[i],
          Constants.MaxValues.MAX_COMMENT_LINE_LENGTH
        ); //chunk the lines into 80 char segments
        userEnteredLines.splice(i, 1, chunkedLines);
      }
    }
    //flatten the array
    coms = _.flatten(userEnteredLines, true);

    //this prevents new lines in the middle of a comment, but lets the user go to a new line to start typing
    var putBackBlankLineAtEnd = false;
    if (coms[coms.length - 1] === "") {
      putBackBlankLineAtEnd = true;
    }
    coms = coms.filter(function (com) {
      return com != "";
    }); //get all the non blank comments

    if (putBackBlankLineAtEnd) {
      coms.push("");
    }

    if (coms.length >= Constants.MaxValues.MAX_COMMENT_lINE_COUNT) {
      //prevent that...
      coms = coms.slice(0, Constants.MaxValues.MAX_COMMENT_lINE_COUNT);
    }

    this.setState({
      showModal: true,
      comments: coms.join("\n"),
      lineCount: coms.length
    });
  },

  render: function () {
    const { isReadOnly, tip, isWeatherRequest, restriction } = this.props;
    var comments = "",
      clsName = "",
      styleName = "";
    var userRole = userStore.getSelectedRole();

    if (this.state.comments) {
      comments = this.state.comments;
    }

    var required = "";
    if (this.props.required) {
      required = "*";
    }
    if (
      userRole.indexOf(Constants.Roles.FIELD_USER) != 0 &&
      this.props.restriction.id != "" &&
      this.props.commentCount > 0
    ) {
      clsName = "commentBorderExist";
      styleName = "info";
    } else {
      clsName = "btn";
      styleName = "info";
    }
    const showSpeedWarn =
      Number(restriction?.freightSpeed) ===
      Number(window.gritConfig.keyTrainSpd);

    const prevSpeedWarn =
      Number(restriction?.prevFreightSpd) ===
      Number(window.gritConfig.keyTrainSpd);

    const speedWarnClass =
      prevSpeedWarn && !showSpeedWarn
        ? "key-train-warning striked"
        : "key-train-warning";

    const effectiveDateTime = `${moment(restriction?.effectiveDate, "MMDDYY").format("MM/DD/YY")} ${moment(restriction?.effectiveTime, "HHmm").format("HH:mm")}`

    return (
      <div>
        <Button
          id="commentsButton"
          bsClass={clsName}
          bsStyle={styleName}
          onClick={this.open}
        >
          {required}Comments: {this.props.commentCount}
        </Button>
        <Modal
          bsSize="large"
          backdrop="static"
          dialogClassName="commentsModal"
          onHide={this.close}
          show={this.state.showModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Comments to be included on restriction prints and GTBs
            </Modal.Title>
          </Modal.Header>

          <div className="modal-body">
            {(prevSpeedWarn || showSpeedWarn) && (
              <span className={speedWarnClass}>
                {window.gritConfig.keyTrainComment}
              </span>
            )}
            <div className="modal-body">
              {(isWeatherRequest && effectiveDateTime) ? (
                <div>
                  <span className="effective-date-time-field">Effective Time:
                    <FormControl
                      className="effective-date-time-field"
                      type="text"
                      id="effectiveDateTimeComment"
                      bsStyle="primary"
                      disabled={true}
                      visible={true}
                      value={effectiveDateTime}
                    />
                  </span>
                </div>
              ) : null}
            </div>
            <textarea
              autoFocus
              ref="commentRef"
              id="comments"
              cols={Constants.MaxValues.MAX_COMMENT_LINE_LENGTH}
              disabled={isReadOnly}
              rows="10"
              value={comments}
              onChange={this.onChange}
              title={isReadOnly ? tip : ""}
            />

            <div>
              Line Count:{this.state.lineCount}
              <span> (Blank lines are removed)</span>
            </div>
          </div>
          <div className="modal-footer">
            {isReadOnly ? null : (
              <Button
                id="commentAddToRequestButton"
                bsStyle="primary"
                disabled={isReadOnly}
                onClick={this.close}
              >
                Add Comment
              </Button>
            )}
            <Button id="commentCancelButton" onClick={this.cancel}>
              Cancel
            </Button>
          </div>
        </Modal>
      </div>
    );
  },
});


function sortFunction(c1, c2) {
  if (c1.lineNumber < c2.lineNumber) {
    return -1;
  }
  if (c1.lineNumber > c2.lineNumber) {
    return 1;
  }
  // a must be equal to b
  return 0;
}
